/* src/app/admin-dashboard/overview/overview.component.css */
.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  padding: 20px;
  width: 100%;
  height: 150px;
  display: inline-block;
  cursor: pointer;
  margin: 10px;
  border: 1px solid black;
}
@media screen and (max-width: 1450px) {
  .card {
    width: 280px;
  }
}
@media screen and (max-device-width: 500px) {
  .card {
    width: 100%;
  }
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}
mat-grid-tile {
  background: lightblue;
}
.container {
  padding: 2px 16px;
}
.main-title {
  font-weight: 300;
  padding-left: 50px;
  padding-top: 50px;
  font-size: 30px;
}
.top-band {
  height: 114px;
  font-family: "Roboto", sans-serif;
  color: white;
  background-color: var(--custom-color);
}
.content {
  text-overflow: ellipsis;
  overflow: hidden;
  max-height: 3.6em;
  line-height: 1.8em;
  border: 1px solid black;
  top: 10px;
  margin-top: 1px;
}
.card-container {
  display: relative;
  max-height: 100%;
}
.title {
  width: 90%;
  max-width: 1240px;
  margin: 0 auto;
  margin-top: 20px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  grid-gap: 10px;
  border: 1px solid black;
}
.actions {
  display: block;
  align-content: left;
  width: 200px;
  height: 50px;
  bottom: 10px;
  float: left;
  margin: 10px;
  border: 1px solid black;
}
.action {
  display: block;
  float: left;
  margin-left: 10px;
  opacity: 0.4;
  transition: 0.3s;
}
/*# sourceMappingURL=overview.component.css.map */
